import React from "react";
import { Box, Typography, Container, Link } from "@mui/material"
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const contactItems = [
    {
        icon: <EmailIcon />,
        label: "Email",
        display: "quinn.peterson@colostate.edu",
        href: "mailto:quinn.peterson@colostate.edu"
    },
    {
        icon: <GitHubIcon />,
        label: "GitHub",
        display: "github.com/Quinn-p",
        href: "https://github.com/Quinn-p"
    },
    {
        icon: <LinkedInIcon />,
        label: "LinkedIn",
        display: "linkedin.com/in/quinn-pete",
        href: "https://www.linkedin.com/in/quinn-pete/"
    }
];

const Contact = () => {
    return (
        <div id="contact">
            <Box sx={{ bgcolor: '#0a0a0a' }}>
                <Container maxWidth="lg" sx={{ py: 10 }}>
                    <Box sx={{ textAlign: 'center', mb: 6 }}>
                        <Typography variant="overline" sx={{ color: '#007FFF', letterSpacing: '0.15em', fontSize: '0.85rem' }}>
                            Get In Touch
                        </Typography>
                        <Typography variant="h3" fontWeight={700} color="white" mt={1}>
                            Contact Me
                        </Typography>
                        <Typography variant="body1" sx={{ color: 'rgba(255,255,255,0.5)', mt: 1 }}>
                            I would love to hear from you — reach out with any questions or opportunities.
                        </Typography>
                    </Box>

                    <Box sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        gap: 3,
                        justifyContent: 'center',
                        alignItems: 'stretch'
                    }}>
                        {contactItems.map((item) => (
                            <Link
                                key={item.label}
                                href={item.href}
                                target={item.href.startsWith('mailto') ? undefined : '_blank'}
                                rel="noopener noreferrer"
                                underline="none"
                                sx={{
                                    flex: '1 1 0',
                                    maxWidth: { sm: 260 },
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    gap: 1.5,
                                    p: 3,
                                    borderRadius: '16px',
                                    border: '1px solid rgba(255,255,255,0.08)',
                                    bgcolor: 'rgba(255,255,255,0.03)',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        bgcolor: 'rgba(0,127,255,0.1)',
                                        borderColor: 'rgba(0,127,255,0.4)',
                                        transform: 'translateY(-4px)',
                                        boxShadow: '0 8px 24px rgba(0,127,255,0.15)'
                                    }
                                }}
                            >
                                <Box sx={{ color: '#007FFF', display: 'flex' }}>
                                    {item.icon}
                                </Box>
                                <Typography variant="subtitle2" color="white" fontWeight={700}>
                                    {item.label}
                                </Typography>
                                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.55)', textAlign: 'center' }}>
                                    {item.display}
                                </Typography>
                            </Link>
                        ))}
                    </Box>
                </Container>
            </Box>
        </div>
    );
};

export default Contact;
